var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.options},on:{"input":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }